import { Button, type LucideIcons, Modal, type SemanticICONS } from '@mairistem/composants';
import type React from 'react';

type ModalConfirmProps = {
  content: React.ReactNode;
  confirmText?: string;
  confirmIcon?: SemanticICONS | LucideIcons;
  cancelText?: string;
  header?: React.ReactNode;
  loading?: boolean;
  size?: 'mini' | 'tiny' | 'small' | 'large' | 'big' | 'huge' | 'massive';
  onConfirm: () => void;
  onCancel: () => void;
};

const ModalConfirm = (props: ModalConfirmProps) => {
  const {
    content,
    header = 'Confirmation',
    confirmText = 'Oui',
    confirmIcon = 'checkmark',
    cancelText = 'Non',
    loading = false,
    onConfirm,
    onCancel,
    size = 'small',
  } = props;

  return (
    <Modal open size={size} onClose={!loading && onCancel} {...(!loading && { closeIcon: true })}>
      <Modal.Header>{header}</Modal.Header>
      <Modal.Content>{content}</Modal.Content>
      <Modal.Actions>
        <Button
          data-testid="modal-confirm-button-cancel"
          onClick={onCancel}
          basic
          size="tiny"
          icon="close"
          content={cancelText}
          disabled={loading}
        />
        <Button
          data-testid="modal-confirm-button-confirm"
          positive
          onClick={onConfirm}
          content={confirmText}
          icon={confirmIcon}
          loading={loading}
          disabled={loading}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default ModalConfirm;
